<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
      <FeedCard
        @click="navigateToArticleByType(ArticleType.BKK)"
        @keydown.enter.prevent="navigateToArticleByType(ArticleType.BKK)"
      >
        <template #icon>
          <img
            v-if="clientStore.brandingLogoBkk"
            :src="clientStore.brandingLogoBkk"
            alt="Bkk Logo"
            width="38"
            height="48"
            class="object-cover"
          />
          <ShieldIcon v-else />
        </template>
        <template #title>{{ t("feed.category.sections.bkk.title") }} </template>
      </FeedCard>
      <FeedCard
        @click="navigateToArticleByType(ArticleType.COMPANY)"
        @keydown.enter.prevent="navigateToArticleByType(ArticleType.COMPANY)"
      >
        <template #icon>
          <img
            v-if="clientStore.brandingLogoCompany"
            :src="clientStore.brandingLogoCompany"
            alt="Company Logo"
            width="38"
            height="48"
            class="object-cover"
          />
          <CompanyIcon v-else />
        </template>
        <template #title>
          {{ t("feed.category.sections.for.me.company.tile.title") }}
        </template>
      </FeedCard>
      <a
        href="https://portal.zentrale-pruefstelle-praevention.de/portfolio/bkk/suche"
        target="_blank"
        rel="noopener noreferrer"
        tabindex="-1"
      >
        <FeedCard>
          <template #icon>
            <ZPPIcon />
          </template>
          <template #title>
            {{ t("feed.category.sections.for.me.zpp.tile.title") }}
          </template>
        </FeedCard>
      </a>
      <FeedCard @click="navigateToFavorite">
        <template #icon>
          <FavoriteCategoryIcon />
        </template>
        <template #title>
          {{ t("dashboard.favorites.tile.title") }}
          {{ t("dashboard.favorites.tile.subtitle") }}
        </template>
      </FeedCard>
    </div>
  </div>
</template>
<script setup lang="ts">
import FeedCard from "./FeedCard.vue";
import { ArticleType } from "../../../enum/v2/articleType.ts";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import ShieldIcon from "../icon/ShieldIcon.vue";
import HouseIcon from "../icon/HouseIcon.vue";
import ZPPIcon from "../icon/ZPPIcon.vue";
import FavoriteCategoryIcon from "../icon/FavoriteCategoryIcon.vue";
import CompanyIcon from "~/components/v2/icon/CompanyIcon.vue";
import { useClientStore } from "~/store/v2/client";

const { t } = useI18n();

const router = useRouter();
const clientStore = useClientStore();

const navigateToArticleByType = (type: string | number) => {
  router.push({ name: "articlesByType", params: { type: type } });
};

function navigateToFavorite() {
  router.push({ name: "favorites" });
}
</script>
